import { productCarousellImages } from '../../common/product-carousell-images';
import { CmsProductCarouselWidget } from './types';

const productFamilies = ['A4100', 'D450', 'D215', 'G450'];

export default {
  categories: [
    {
      key: 'all-products',
      value: 'All Products',
    },
    {
      key: 'phones',
      value: 'Phones',
    },
    {
      key: 'tablets',
      value: 'Tablets',
    },
    {
      key: 'watches',
      value: 'Watches',
    },
  ],
  items: [...productCarousellImages.filter((p) => productFamilies.includes(p.productId))],
} as CmsProductCarouselWidget;
